class SalutBundle extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.product-bundle-salut');
    this.list = this.querySelector('product-recommendations');
    this.button = this.querySelector('[data-salut-bundle-add]');
    this.spinner = this.querySelector('.product-bundle-salut__spinner');
    this.addedState = this.querySelector('[data-salut-bundle-added]');
    this.totalNode = this.querySelector('[data-salut-bundle-total]');
    this.wasNode = this.querySelector('[data-salut-bundle-was]');
    this.extraPercent = parseInt(this.dataset.extraPercent, 10) || 0;

    this.onChange = this.onChange.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);

    this.addEventListener('change', this.onChange);
    this.button.addEventListener('click', this.onAdd);
    document.addEventListener('variant-change', this.onVariantChange);

    if (document.querySelector('cart-drawer')) {
      customElements.whenDefined('cart-drawer').then(() => document.querySelector('cart-drawer').init());
    }

    this.observer = new MutationObserver(this.onRecommendations.bind(this));
    this.observer.observe(this.list, { childList: true });

    this.update();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    document.removeEventListener('variant-change', this.onVariantChange);
  }

  get rows() {
    return Array.from(this.querySelectorAll('.product-bundle-salut__row:not(.product-bundle-salut__row--loading)'));
  }

  get selected() {
    return Array.from(this.querySelectorAll('[data-salut-bundle-item]')).filter((input) => input.checked);
  }

  onRecommendations() {
    if (this.list.querySelector('[data-salut-bundle-empty]')) {
      this.hide();
      return;
    }

    this.list.querySelectorAll('.product-bundle-salut__row--loading').forEach((row) => row.remove());

    const limit = parseInt(this.dataset.count, 10) || 0;
    this.list
      .querySelectorAll('.product-bundle-salut__row')
      .forEach((row, index) => {
        if (index >= limit) row.remove();
      });

    if (!this.list.querySelector('.product-bundle-salut__row')) {
      this.hide();
      return;
    }

    this.removeAttribute('aria-busy');
    this.update();
  }

  hide() {
    if (this.section) this.section.hidden = true;
  }

  onChange(event) {
    if (!event.target.matches('[data-salut-bundle-item]')) return;
    this.resetButton();
    this.update();
  }

  onVariantChange(event) {
    const variant = event.detail?.variant;
    const row = this.querySelector('.product-bundle-salut__row--current');
    if (!variant || !row) return;

    const input = row.querySelector('[data-salut-bundle-item]');
    const compare = variant.compare_at_price > variant.price ? variant.compare_at_price : 0;

    input.value = variant.id;
    input.dataset.price = variant.price;
    input.dataset.compare = compare;
    input.checked = variant.available;

    row.querySelector('.product-bundle-salut__price-now').textContent = this.money(variant.price);
    this.renderRowCompare(row, compare);

    this.resetButton();
    this.update();
  }

  renderRowCompare(row, compare) {
    const stack = row.querySelector('.product-bundle-salut__price-stack');
    const was = row.querySelector('.product-bundle-salut__price-was');
    const chip = row.querySelector('.product-bundle-salut__row-chip');
    const price = parseInt(row.querySelector('[data-salut-bundle-item]').dataset.price, 10);

    if (compare <= 0) {
      was?.remove();
      chip?.remove();
      return;
    }

    if (was) {
      was.textContent = this.money(compare);
    } else {
      const node = document.createElement('s');
      node.className = 'product-bundle-salut__price-was';
      node.textContent = this.money(compare);
      stack.appendChild(node);
    }

    const percent = `-${Math.round(((compare - price) / compare) * 100)}%`;
    if (chip) {
      chip.textContent = percent;
    } else {
      const node = document.createElement('span');
      node.className = 'product-bundle-salut__row-chip';
      node.textContent = percent;
      stack.parentElement.appendChild(node);
    }
  }

  update() {
    const selected = this.selected;
    const subtotal = selected.reduce((sum, input) => sum + parseInt(input.dataset.price, 10), 0);
    const total = selected.reduce((sum, input) => {
      const price = parseInt(input.dataset.price, 10);
      return sum + price - Math.floor((price * this.extraPercent) / 100);
    }, 0);

    this.totalNode.textContent = this.money(total);

    const discounted = subtotal > total;
    this.wasNode.hidden = !discounted;
    if (discounted) this.wasNode.textContent = this.money(subtotal);

    this.button.setAttribute('aria-disabled', selected.length === 0);
  }

  resetButton() {
    clearTimeout(this.addedTimer);
    this.addedState.hidden = true;
  }

  showAdded() {
    this.addedState.hidden = false;
    this.addedTimer = setTimeout(() => {
      this.addedState.hidden = true;
    }, 2500);
  }

  money(cents) {
    const format = this.dataset.moneyFormat || '{{amount}}';
    const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!placeholder) return format;

    const value = cents / 100;
    let amount;

    switch (placeholder[1]) {
      case 'amount_no_decimals':
        amount = this.number(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        amount = this.number(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        amount = this.number(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        amount = this.number(value, 2, "'", '.');
        break;
      default:
        amount = this.number(value, 2, ',', '.');
    }

    return format.replace(placeholder[0], amount);
  }

  number(value, decimals, thousands, decimal) {
    const parts = value.toFixed(decimals).split('.');
    const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? `${whole}${decimal}${parts[1]}` : whole;
  }

  onAdd() {
    if (this.button.getAttribute('aria-disabled') === 'true') return;

    const items = this.selected.map((input) => ({ id: parseInt(input.value, 10), quantity: 1 }));
    if (items.length === 0) return;

    const drawer = document.querySelector('cart-drawer');
    const body = { items };

    if (drawer) {
      body.sections = drawer.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }

    this.resetButton();
    this.button.setAttribute('aria-disabled', true);
    this.button.classList.add('is-loading');
    this.spinner.hidden = false;
    this.setAttribute('aria-busy', 'true');

    const config = fetchConfig('javascript');
    config.body = JSON.stringify(body);

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'salut-bundle',
            errors: response.errors || response.description,
            message: response.message,
          });
          return;
        }

        this.showAdded();

        if (drawer && response.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(response);
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'salut-bundle',
          cartData: response,
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.spinner.hidden = true;
        this.button.classList.remove('is-loading');
        this.removeAttribute('aria-busy');
        this.update();
      });
  }
}

customElements.define('salut-bundle', SalutBundle);
